/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const getFulfillingPharmaciesGql = gql`
  query getFulfillingPharmacies($pharmacyId: UUID!) {
    getFulfillingPharmacies(pharmacyId: $pharmacyId) {
      city
      fulfillingPharmacyId
      line1
      line2
      name
      npi
      pharmacist
      pharmacyType
      phone
      state
      zip
      config {
        rxPrefix
      }
      shipmentConfig {
        shipmentRoutes {
          routeTo
          availableRoutes
        }
        shipmentProviders {
          spType
          storeId
        }
      }
    }
  }
`;

export const updateFulfillingPharmacyShippingDefaultGql = gql`
  mutation updateFulfillingPharmacyShippingDefault(
    $fulfillingPharmacyId: String!
    $routeTo: ShipmentMode!
  ) {
    updateFulfillingPharmacyShippingDefault(
      fulfillingPharmacyId: $fulfillingPharmacyId
      routeTo: $routeTo
    )
  }
`;

export const transferOrderToFacilityGql = gql`
  mutation transferOrderFulfillingPharmacy(
    $orderIds: [String!]
    $lineItemIds: [UUID!]
    $fulfillingPharmacyId: UUID!
  ) {
    transferOrderFulfillingPharmacy(
      orderIds: $orderIds
      lineItemIds: $lineItemIds
      fulfillingPharmacyId: $fulfillingPharmacyId
    ) {
      results
      outcomes {
        orderId
        lineItemIds
        isTransferred
        reason
        resultingOrderId
      }
      totalRequested
      totalTransferred
      totalIneligible
    }
  }
`;

export const addExternalTransferPharmacyGql = gql`
  mutation addExternalTransferPharmacy($input: AddExternalTransferPharmacyInput!) {
    addExternalTransferPharmacy(input: $input) {
      pharmacyId
      pharmacyName
      addressLine1
      addressLine2
      city
      state
      zip
      phone
      fax
      npi
      dea
      pharmacistName
      isThirdParty
      createdTimestamp
      modifiedTimestamp
    }
  }
`;

export const listPharmaciesGql = gql`
  query listPharmacies($filter: ListPharmaciesFilter, $sortBy: ListPharmaciesSortBy) {
    listPharmacies(filter: $filter, sortBy: $sortBy) {
      count
      results {
        pharmacyId
        pharmacyName
        addressLine1
        addressLine2
        city
        state
        zip
        phone
        fax
        npi
        dea
        pharmacistName
        pharmacistNpi
        isThirdParty
        createdTimestamp
        modifiedTimestamp
      }
    }
  }
`;

export const transferOrdersToExternalPharmacyGql = gql`
  mutation transferOrdersToExternalPharmacy($input: TransferOrdersToExternalPharmacyInput!) {
    transferOrdersToExternalPharmacy(input: $input) {
      results {
        orderId
        success
        errorMessage
      }
    }
  }
`;

export const editExternalTransferPharmacyGql = gql`
  mutation editExternalTransferPharmacy($input: EditExternalTransferPharmacyInput!) {
    editExternalTransferPharmacy(input: $input) {
      pharmacyId
      pharmacyName
      addressLine1
      addressLine2
      city
      state
      zip
      phone
      fax
      npi
      dea
      pharmacistName
      isThirdParty
      createdTimestamp
      modifiedTimestamp
    }
  }
`;

export const deleteExternalTransferPharmacyGql = gql`
  mutation deleteExternalTransferPharmacy($pharmacyId: String!) {
    deleteExternalTransferPharmacy(pharmacyId: $pharmacyId)
  }
`;
export const listFulfillingPharmaciesGql = gql`
  query listFulfillingPharmacies($filter: ListFulfillingPharmaciesFilter) {
    listFulfillingPharmacies(filter: $filter) {
      count
      results {
        fulfillingPharmacyId
        pharmacyId
        name
        streetAddress1
        streetAddress2
        city
        state
        zip
        phone
        fax
        npi
        pharmacist
        pharmacistNpi
        isActive
        isDeleted
        isDefault
        createdTimestamp
        modifiedTimestamp
      }
    }
  }
`;
